import Text from "../../../../../../../../components/Text";

/**
 *
 * @param time: number
 * @description: To format the time in the format of HH:MM:SS
 *
 * @returns string
 *
 * @author [Rajkumar Rathod]
 */
const Timer = ({ time }: { time: number }) => {
  const padStart = (value: number, length: number) =>
    value.toString().padStart(length, "0");

  const getTime = (time: number) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${padStart(hours, 2)} :${padStart(minutes, 2)} :${padStart(
      seconds,
      2
    )}`;
  };

  return (
    <Text
      variant="caption"
      sx={{ fontSize: "12px", color: "text.secondary", maxHeight: "16px" }}
    >
      {getTime(time)}
    </Text>
  );
};

export default Timer;
